import { render, staticRenderFns } from "./PDFPageMobile.vue?vue&type=template&id=2d438e34&scoped=true"
import script from "./PDFPageMobile.vue?vue&type=script&lang=js"
export * from "./PDFPageMobile.vue?vue&type=script&lang=js"
import style0 from "./PDFPageMobile.vue?vue&type=style&index=0&id=2d438e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d438e34",
  null
  
)

export default component.exports